<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <Affix :offset-top="110">
    <div class="userinfo-nav">
      <div :class="['nav-title' , $route.name == 'userInfo' && 'current']" @click="handleChangeRoute('userInfo')">{{'个人中心' | dealLanguage('Personal center')}}</div>
      <div :class="['nav-title' , $route.name == 'myTickets' && 'current']" @click="handleChangeRoute('myTickets')">{{'我的门票' | dealLanguage('My Tickets')}}</div>
      <div :class="['nav-title' , $route.name == 'orderList' && 'current']" @click="handleChangeRoute('orderList')">{{'订单和发票' | dealLanguage('Orders and Invoices')}}</div>
      <!-- <div :class="['nav-title' , ['companions', 'addCompanions'].includes($route.name) && 'current']" @click="handleChangeRoute('companions')">{{'同行人' | dealLanguage('Companion')}}</div> -->
      <!-- <div :class="['nav-title']">同行人</div> -->
    </div>
  </Affix>
</template>
<script>
export default {
  components: {},
  created() {},
  mounted() {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    handleChangeRoute(name) {
      if(name == this.$route.name) return
      this.$router.push({ name })
    }
  },
}
</script>
<style lang='stylus' scoped>
.userinfo-nav
  padding-top 30px
  .nav-title
    font-size 16px
    color #999999
    line-height 22px
    display flex
    align-items center
    cursor pointer
    transition all 0.3s
    &+.nav-title
      margin-top 20px
    &:hover
      color #333333
    &.current
      color #333333
      &::before
        content ''
        width 2px
        height 18px
        background #4E77DF
        margin-right 10px
        transition all 0.3s
</style>